export const ACTIVE_MARKER_ICON =
  'https://caterpillar.scene7.com/is/image/Caterpillar/CM20230710-ca827-064e8?wid=38&hei=44&fmt=png-alpha';
export const INACTIVE_MARKER_ICON =
  'https://caterpillar.scene7.com/is/image/Caterpillar/CM20230710-e9c21-3c35d?wid=38&hei=44&fmt=png-alpha';